import type { MakeItem } from './makeApi';

// Normalizes a vendor price string into a JS number, handling EU/JP grouping.
// Mirrors priceNormalizer() from the legacy website/js/make.js.
export function normalizePriceToNumber(
  raw: string | number | undefined | null,
  locale: string,
): number {
  if (raw == null) return 0;

  let s = String(raw);

  if (!s.includes('.') && s.includes(',')) {
    // e.g. "1.200" grouping vs "46,99" decimal comma
    s = locale === 'jp' ? s.split(',').join('') : s.split(',').join('.');
  } else if (s.includes('.') && s.includes(',')) {
    // e.g. "1,200.99" -> "1200.99"
    s = s.split(',').join('');
  }

  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
}

// Items with a usable price, cheapest first (priceless items dropped).
export function cheapestFirst(items: MakeItem[]): MakeItem[] {
  return items
    .filter((i) => normalizePriceToNumber(i.price, 'us') > 0)
    .sort((a, b) => normalizePriceToNumber(a.price, 'us') - normalizePriceToNumber(b.price, 'us'));
}
